"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ExpressCartModal = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _checkouts = require("@px/checkouts");
var _button = _interopRequireDefault(require("@ux/button"));
var _chevronLeft = _interopRequireDefault(require("@ux/icon/chevron-left"));
var _spinner = _interopRequireDefault(require("@ux/spinner"));
var _growl = _interopRequireDefault(require("@ux/growl"));
var _space = require("@ux/space");
var _text = _interopRequireDefault(require("@ux/text"));
var _ContactSupportMessage = _interopRequireDefault(require("./ContactSupportMessage"));
var _PromptRecommendations = require("../../styles/PromptRecommendations");
var _constants = require("../../constants");
// TODO: [USIDOM-1465] Look into express cart feature when migrating to conversation search result
const ExpressCartModal = ({
  closeModal,
  basketId,
  noGrowl = false,
  onBack,
  onError,
  appKey
}) => {
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "express-cart-modal"
  }, /*#__PURE__*/_react.default.createElement(_PromptRecommendations.StyledExpressCartModal, {
    id: "modal-express-checkout",
    "data-testid": "express-cart-modal",
    className: "domain-search-recommendations-xc-modal",
    onClose: closeModal,
    space: {
      inline: _space.sizeOptions.LG,
      block: _space.sizeOptions.LG
    },
    title: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
  }, onBack && /*#__PURE__*/_react.default.createElement(_button.default, {
    size: "small",
    className: "back-button",
    icon: /*#__PURE__*/_react.default.createElement(_chevronLeft.default, null),
    text: formatMessage({
      id: 'Back'
    }),
    onClick: onBack
  }), /*#__PURE__*/_react.default.createElement(_checkouts.Checkout, {
    basketId: basketId,
    id: "domain-search-box-express-checkout",
    appKey: appKey,
    containerId: "hoverContainer",
    checkoutName: "ExpressCart",
    onError: () => {
      _growl.default.addGrowlMessage({
        id: 'expressCartErrorGrowl',
        title: /*#__PURE__*/_react.default.createElement(_text.default.h2, {
          as: "title",
          text: formatMessage({
            id: 'growl.error.title'
          })
        }),
        emphasis: 'critical',
        children: /*#__PURE__*/_react.default.createElement(_ContactSupportMessage.default, null),
        lifetime: 5000
      });
      onError?.();
    },
    onPurchaseSuccess: () => {
      if (!noGrowl) {
        _growl.default.addGrowlMessage({
          id: 'expressCartSuccessGrowl',
          title: /*#__PURE__*/_react.default.createElement(_text.default.h2, {
            as: "title",
            text: 'searchRecommendation.purchase.complete'
          }),
          emphasis: 'success',
          children: formatMessage({
            id: 'searchRecommendation.purchase.complete.description'
          }),
          lifetime: 5000
        });
      }
      closeModal(_constants.REQUEST_STATUS.SUCCESS);
    },
    loadingSpinner: /*#__PURE__*/_react.default.createElement(_spinner.default, null)
  })));
};
exports.ExpressCartModal = ExpressCartModal;
ExpressCartModal.propTypes = {
  closeModal: _propTypes.default.func.isRequired,
  basketId: _propTypes.default.string.isRequired,
  noGrowl: _propTypes.default.bool,
  onError: _propTypes.default.func,
  onBack: _propTypes.default.func,
  appKey: _propTypes.default.string
};
var _default = exports.default = ExpressCartModal;